import React from 'react'

import { useTranslation } from 'react-i18next'

import { Stack, Text } from '@enechain/ecloud-designsystem'
import { FaTableRegular } from '@enechain/ecloud-icons'

export const SimulationEmptyResult: React.FC = () => {
  const { t } = useTranslation(['page'])

  return (
    <Stack
      backgroundColor="Surface.secondary"
      paddingX="8"
      paddingTop="8"
      paddingBottom="12"
      borderRadius="radiiXl"
      alignItems="center"
      justifyContent="center"
      gap="2"
    >
      <FaTableRegular width="40px" height="40px" color="Text.lowEmphasis" />
      <Stack gap="1" alignItems="center">
        <Text textStyle="headerSm" color="Text.midEmphasis">
          {t('page:simulation.no_result')}
        </Text>
        <Text textStyle="textSm" color="Text.lowEmphasis">
          {t('page:simulation.no_result_description')}
        </Text>
      </Stack>
    </Stack>
  )
}
